import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'

/**
 * Component to skip the currents step.
 */
class SkipStep extends Component {
	
	/**
	 * Constructor.
	 * 
	 * @param props the properties object
	 * @param props.orderId the order id
	 * @param props.reqId (optional) the gear requisition id if we are skipping a req step
	 * @param props.stepKey the step key (see withWorkflow.workflowMetaData for object keys)
	 * @param props.getWorkflowStep function to get the workflow step by step key
	 * @param props.setGearOrder function to set the updated GEAR order
	 * @param props.setDirty function to mark a step as dirty/clean
	 * @param props.updateStep function to update the workflow state to a new step
	 */
	constructor(props) {
		super(props);
		
		this.skipStep = this.skipStep.bind(this);
	}
	
	/**
	 * Skips the current step.
	 */
	skipStep() {
		let step = this.props.getWorkflowStep(this.props.stepKey);
		let url = `${process.env.REACT_APP_GEAR_REST_URL}/order/${this.props.orderId}/skip-step/${step.id}`;
		if (this.props.reqId) {
			url = url + '/' + this.props.reqId;
		}
		fetch(url, {
			method: "PUT",
			credentials: "include",
			mode: "cors",
			timeout:1000,
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			}
		})
		.then(response => {return response.json(); })
		.then(json => {
			if (json.id){
				this.props.setGearOrder(json);
				this.props.setDirty(false);
				this.props.updateStep(json, this.props.stepKey, "Next");
			} else if (json.errors){
				this.setState({
					showError: true,
					errorMessage: json.errors[0].field+' '+json.errors[0].defaultMessage
				});
			}
		})
		.catch(error => { 
			this.setState({
				showError:true,
				errorMessage: "The network is currently unavailable. Please call us at 800-522-4762."
			});
		});
	}
	
	render() {
		if (this.props.hidden || this.props.userType !== "myGDX") {
			return null;
		}

		// Do not show Skip if the step has been completed
		const step = this.props.getWorkflowStep(this.props.stepKey);
		if( !step || step.completed ) {
			return null;
		}
		
		return (
			<div className="alert alert-info skip-step">
				<p className="pull-left">Not ready to enter this information? Skip this step and the patient may provide details at a later date.</p>
				<button className="btn btn-primary rounded-pill btn-sm pull-right" type="button" onClick={this.skipStep}>
					Skip <i className="ps-2 fa fa-arrow-circle-right"></i>
				</button>
			</div>
		);
	}
}
export default withRouter(SkipStep);
